var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCastle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49613 4.04394C2.18891 4.22315 2 4.55205 2 4.90771V10C2 10.5523 2.44772 11 3 11V21.25H2C1.58579 21.25 1.25 21.5858 1.25 22C1.25 22.4142 1.58579 22.75 2 22.75H22C22.4142 22.75 22.75 22.4142 22.75 22C22.75 21.5858 22.4142 21.25 22 21.25H21V11C21.5523 11 22 10.5523 22 10V4.90771C22 4.55205 21.8111 4.22315 21.5039 4.04394L18.5039 2.29394C18.1925 2.11231 17.8075 2.11231 17.4961 2.29394L14.4961 4.04394C14.1889 4.22315 14 4.55205 14 4.90771V10C14 10.5523 14.4477 11 15 11V14.3062C13.0294 14.7865 10.9706 14.7865 9 14.3062V11C9.55228 11 10 10.5523 10 10V4.90771C10 4.55205 9.81109 4.22315 9.50387 4.04394L6.50387 2.29394C6.19251 2.11231 5.80749 2.11231 5.49613 2.29394L2.49613 4.04394ZM15 21.25H9V15.8453C10.9766 16.2735 13.0234 16.2735 15 15.8453V21.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastle);
export default __webpack_public_path__ + "static/media/castle.76cc32bc0e963ad2654e2116f50cf574.svg";
export { ForwardRef as ReactComponent };